import { App } from 'vue';
import { SnackbarKey } from '@/symbols';
import { useSnackbar } from '@/util/snack-bar';

export default {
    install(app: App) {
        const snackbar = useSnackbar();       
        app.config.globalProperties.$snackbar = snackbar;
        app.provide(SnackbarKey, snackbar);
    }
};

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $snackbar: any
    }
}
